import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    title: string;
    className?: string;
}

export const DetailViewHeader = (props: IProps) => {
    const {title, className} = props;

    return (
        <Text variant="headline_4" as="h2" className={cx(className, headingStyle)}>
            {title}
        </Text>
    );
};

const headingStyle = css({
    pb: 3,

    sm: {
        pb: 4
    }
});
